import React from 'react'
import {
    Edit,
    TextInput,
    BooleanInput,
    ReferenceInput,
    SelectInput,
} from 'react-admin'

import { CustomSimpleForm } from '../Generic'

export const DatoTecnicoEdit = props => (
    <Edit {...props}>
        <CustomSimpleForm>
            <TextInput source="name" label="Nombre" />
            <TextInput source="description" label="Descripción" />
            <BooleanInput source="active" label="Activo"/>
            <ReferenceInput source="datasheet_type" reference="esquemas-datos-tecnicos" label="Esquema">
                <SelectInput optionText="name"/>
            </ReferenceInput>
        </CustomSimpleForm>
    </Edit>
);
